/* eslint-disable no-shadow */
export enum VitalFlagTypes {
  POSITIVE = 'positive',
  NEGATIVE = 'negative',
  CRITICAL = 'critical',
}

export enum VitalFlagTier {
  ['TIER-ONE'] = 1,
  ['TIER-TWO'] = 2,
  ['TIER-THREE'] = 3,
}

export enum VitalFlagCategory {
  BLOOD_PRESSURE = 'Blood Pressure',
  BLOOD_GLUCOSE = 'Blood Glucose',
  PULSE_OX = 'Pulse Ox',
  WEIGHT = 'Weight',
  SLEEP = 'Sleep',
  CALORIES = 'Calories',
  TEMPERATURE = 'Temperature',
  PULSEBPM = 'Pulse Bpm',
  PEAKFLOW = 'Peak Flow',
  FORCEDAIR = 'Forced Air',
  PILLLBOX = 'Pill Box',
}

export enum VitalFlagComparitors {
  MEASURES = 'measures',
  DAYS = 'days',
  FIXED = 'fixed',
}
export enum VitalFlagComparitorTypes {
  PERCENT = 'percent',
  NUMBER = 'number',
}
export enum VitalFlagOffsetTypes {
  PLUS = '+',
  MINUS = '-',
}
export enum VitalFlagOffsetTypesLabels {
  PLUS = 'Add (+)',
  MINUS = 'Substract (-)',
}

export enum VitalFlagOperators {
  LESS = '<',
  GREATER = '>',
  EQUALS = '==',
  LESS_EQUAL = '<=',
  GREATER_EQUAL = '>=',
}

export enum VitalFlagOperatorsLabels {
  LESS = 'I want to know about measures below this target',
  GREATER = 'I want to know about measures exceed this target',
  EQUALS = 'I want to know about measures equal to this target',
  LESS_EQUAL = 'I want to know about measures below or equal to this target',
  GREATER_EQUAL = 'I want to know about measures are equal to or exceed this target',
}

export interface VitalFlagLabelModel {
  value: string;
  label: string;
}

export enum VitalFlagBloodPressureSecondary {
  SYSTOLIC_BP = 'Systolic',
  DIASTOLIC_BP = 'Diastolic',
}

export interface ComparitorOption {
  value: string;
  label: string;
  tooltip: string;
}

export interface SliderConfig {
  rows: Array<{ label: string; secondary: boolean }>;
  min: number;
  max: number;
  step: number;
}

export interface SliderRow {
  label: string;
  secondary: boolean;
  values: number[];
  min: number;
  max: number;
  step: number;
  mode: 'symmetric' | 'low-to-high' | 'high-to-low';
}

export interface EditableTierRow {
  tier: number;
  tierLabel: string;
  tierColor: string;
  offset_amount: number;
  count: number;
  offset_type: string;
  operator: string;
}

export interface TierNotification {
  tier: number;
  tierLabel: string;
  tierColor: string;
  alert_provider: boolean;
  alert_patient: boolean;
}

export interface VitalFlagDefault {
  id?: string;
  active: boolean;
  alert_patient: boolean;
  alert_provider: boolean;
  comparitor: string;
  comparitor_type: string;
  count: number;
  notes: string;
  offset_amount: number;
  offset_type: string;
  operator: string;
  secondary: boolean;
  tier: number;
  type: string;
}

export const VITAL_FLAG_SLIDER_CONFIGS: Record<string, SliderConfig> = {
  [VitalFlagCategory.BLOOD_PRESSURE]: {
    rows: [
      { label: 'Systolic', secondary: false },
      { label: 'Diastolic', secondary: true },
    ],
    min: 20,
    max: 250,
    step: 1,
  },
  [VitalFlagCategory.BLOOD_GLUCOSE]: {
    rows: [{ label: 'Measures', secondary: false }],
    min: 20,
    max: 500,
    step: 1,
  },
  [VitalFlagCategory.PULSE_OX]: {
    rows: [{ label: 'Measures', secondary: false }],
    min: 50,
    max: 100,
    step: 1,
  },
  [VitalFlagCategory.WEIGHT]: {
    rows: [{ label: 'Measures', secondary: false }],
    min: 50,
    max: 500,
    step: 1,
  },
  [VitalFlagCategory.SLEEP]: {
    rows: [{ label: 'Measures', secondary: false }],
    min: 0,
    max: 24,
    step: 1,
  },
  [VitalFlagCategory.CALORIES]: {
    rows: [{ label: 'Measures', secondary: false }],
    min: 0,
    max: 5000,
    step: 10,
  },
  [VitalFlagCategory.TEMPERATURE]: {
    rows: [{ label: 'Measures', secondary: false }],
    min: 90,
    max: 110,
    step: 0.1,
  },
  [VitalFlagCategory.PULSEBPM]: {
    rows: [{ label: 'Measures', secondary: false }],
    min: 20,
    max: 220,
    step: 1,
  },
  [VitalFlagCategory.PEAKFLOW]: {
    rows: [{ label: 'Measures', secondary: false }],
    min: 0,
    max: 900,
    step: 1,
  },
  [VitalFlagCategory.FORCEDAIR]: {
    rows: [{ label: 'Measures', secondary: false }],
    min: 0,
    max: 100,
    step: 1,
  },
  [VitalFlagCategory.PILLLBOX]: {
    rows: [{ label: 'Measures', secondary: false }],
    min: 0,
    max: 10,
    step: 1,
  },
};
